export default __webpack_public_path__ + "static/media/icon-seta.71f951bc.svg";